import { Center, Divider, Stack } from '@mantine/core';
import { IconArrowLeft, IconExternalLink } from '@tabler/icons-react';
import H2Medium from 'components/typography/H2Medium';
import P1Regular from 'components/typography/P1Regular';
import SimpleLayout from 'layouts/simple/SimpleLayout';
import { Link, useSearchParams } from 'react-router-dom';
import Button from 'components/Button';

/**
 * Intermediate page shown when the user is about to leave Objekto
 * and be redirected to the BrainIT signing portal.
 */
export default function ExternalRedirectPage() {
  const [searchParams] = useSearchParams();

  const targetUrl = searchParams.get('targetUrl') || '';
  const returnUrl = searchParams.get('returnUrl') || -1;

  return (
    <SimpleLayout>
      <Stack p={24} spacing={16}>
        <Center>
          <Center bg="blue.6" w={44} h={44} style={{ borderRadius: '100%' }}>
            <IconExternalLink stroke={2} width={24} height={24} color="white" />
          </Center>
        </Center>
        <Stack spacing={4}>
          <H2Medium align="center" color="gray.8">
            Odchádzate z Objekto
          </H2Medium>
          <P1Regular align="center" color="gray.7">
            Pre podpísanie dokumentov budete presmerovaný na externú stránku systému Brain:IT.
          </P1Regular>
        </Stack>
      </Stack>

      <Divider color="gray.1" />

      <Stack p={24} pb={20} spacing={20}>
        <Button
          component="a"
          href={targetUrl}
          rel="external noreferrer"
          target="_blank"
          fullWidth
          size="lg"
          variant="primary"
        >
          Prejsť na podpisovanie
        </Button>
        <Button
          component={Link}
          to={returnUrl as any}
          fullWidth
          size="sm"
          variant="subtle-gray"
          leftIcon={<IconArrowLeft />}
        >
          Návrať späť
        </Button>
      </Stack>
    </SimpleLayout>
  );
}
